export default __webpack_public_path__ + "static/mens-f9718e1e410e4fdc6cc5b244091a958a.jpg";